/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_ConfirmInputs */

const en_us2_onboarding_confirm = /** @type {(inputs: Onboarding_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const pt_br2_onboarding_confirm = /** @type {(inputs: Onboarding_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const es_419_onboarding_confirm = /** @type {(inputs: Onboarding_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const pt_pt2_onboarding_confirm = /** @type {(inputs: Onboarding_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const fr_fr2_onboarding_confirm = /** @type {(inputs: Onboarding_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const de_de2_onboarding_confirm = /** @type {(inputs: Onboarding_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const it_it2_onboarding_confirm = /** @type {(inputs: Onboarding_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Onboarding_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_confirm = /** @type {((inputs?: Onboarding_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_confirm(inputs)
	if (locale === "es-419") return es_419_onboarding_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_confirm(inputs)
	if (locale === "de-DE") return de_de2_onboarding_confirm(inputs)
	if (locale === "it-IT") return it_it2_onboarding_confirm(inputs)
	return en_us2_onboarding_confirm(inputs)
});
export { onboarding_confirm as "onboarding.confirm" }